<template>
  <div class="media-panel z3">
    <div class="panel-header center">
      <div class="button-back caps z2 hide-print pointer hover-red" @click="$emit('close')">
        Close
      </div>
      <h3 class="caps text-overflow xs-hide">{{ content.title }}</h3>
    </div>
    <div class="media-items flex flex-wrap">
      <div v-for="(item, index) in media" class="media-item col-12 sm-col-4 md-col-3 center mb3" :key="index">
        <!-- DOCUMENT IMAGES -->
        <div
          v-if="item.hasOwnProperty('type') && item.type === 'document-image'"
          @click="$emit('open-slideshow-item', getSlideshowIndex(index))"
          class="cursor-zoom-in hover-toggle">
          <div class="image flex items-center center gallery">
            <img :src="item.thumb" class="mx-auto" />
          </div>
          <div class="caption fs-s p1">
            <span class="hover-hide" v-html="item.title" />
            <div class="hover-show caps">
              Open in Gallery
            </div>
          </div>
        </div>
        <!-- IMAGES -->
        <div
          v-else-if="item.hasOwnProperty('type') && item.type === 'image'"
          @click="$emit('open-slideshow-item', getSlideshowIndex(index))"
          class="cursor-zoom-in hover-toggle">
          <div class="image flex items-center center gallery">
            <img :src="item.sizes.medium" class="mx-auto" />
          </div>
          <div class="caption fs-s p1">
            <span class="hover-hide">{{ item.title | truncate(32) }}</span>
            <div class="hover-show caps">
              Open in Gallery
            </div>
          </div>
        </div>

        <!-- VIDEOS -->
        <div v-else-if="item.hasOwnProperty('video')"
          @click="updateCurrentVideo(item)"
          class="hover-toggle pointer">
          <div class="video flex items-center center relative">
            <img :src="videoThumbnail(item)" class="mx-auto" />
          </div>
          <div class="caption fs-s p1">
            <span class="hover-hide"><span class="pr1">▶</span> {{ videoTitle(item) | truncate(32) }}</span>
            <div class="flex hover-show">
              <div class="flex-auto">{{ videoLength(item) }}</div>
              <div class="caps flex-auto">Play Film</div>
            </div>
          </div>
        </div>

        <!-- FILES etc -->
        <div v-else-if="item !== false">
          <a :href="item.url" target="_blank" class="hover-toggle">
            <div class="file flex items-center center relative">
              <img :alt="`Download ${item.title}`" src="../assets/icon-document.svg" class="mx-auto no-border" />
              <div class="filetype fs-l" v-text="getExtension(item)"></div>
            </div>
            <div class="caption fs-s p1">
              <span class="hover-hide">{{ item.title }}</span>
              <div class="hover-show caps">
                Download File
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import PanelHeader from '@/components/PanelHeader'
import { strPadLeft, getVideoTimeFromSeconds } from '@/utils.js'

export default {

  name: 'Resources',

  components: {
    PanelHeader
  },

  props: ['content', 'documentMedia', 'ss'],

  mounted () {
    document.addEventListener("keyup", this.resourceNav)
  },

  destroyed () {
    document.removeEventListener("keyup", this.resourceNav)
  },

  computed: {
    ...mapState([
      'currentVideo'
    ]),
    media () {
      let mediaItems = this.content.acf.media || []

      if (this.documentMedia) {
        mediaItems = this.documentMedia.concat(mediaItems)
      }

      if (this.content.acf.featured.feature_video) {
        mediaItems = this.content.acf.featured.feature_video.concat(mediaItems)
      }

      // Skip video rows saved without a video selected
      return mediaItems.filter(item => !(item && item.hasOwnProperty('video') && !item.video.object))
    },
    slideshowItems () {
      return this.media.filter( item => {
        return (item.type === 'image' || item.type === 'document-image')
      })
    }
  },
  methods: {
    ...mapActions([
      'updateCurrentVideo'
    ]),
    strPadLeft,
    getVideoTimeFromSeconds,
    resourceNav () {
      if (!this.ss & !this.currentVideo) {
        if (event.key === "Escape") {
          this.$emit('close')
        }
      }
    },
    getSlideshowIndex (index) {
      let itemId = this.media[index].ID
      return this.slideshowItems.map(function(e) { return e.ID; }).indexOf(itemId)
    },
    videoLength (item) {
      return this.getVideoTimeFromSeconds(JSON.parse(item.video.object).duration)
    },
    videoTitle (item) {
      let itemJSON = JSON.parse(item.video.object)
      return itemJSON.name
    },
    videoThumbnail (item) {
      let itemJSON = JSON.parse(item.video.object)
      return itemJSON.pictures.sizes.find(item => item.width === 640).link
    },
    getExtension (item) {
      if (item.hasOwnProperty('filename')) {
        return item.filename.substring(item.filename.lastIndexOf('.'))
      } else {
        return 'none'
      }

    }
  }
}
</script>

<style lang="css" scoped>
  .media-panel {
    padding: 3em;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: var(--black);
    color: var(--col-light);
    overflow-y: scroll;
    z-index: 10000;

    a {
      color: var(--col-light);
    }
  }

  .media-item {
    div.caption {
      margin-left: 10%;
      margin-right: 10%;
      border: 1px solid var(--black);
    }

    div.image, div.video, div.file {
      height: 20vw;
      overflow: hidden;

      img {
        max-height: 80%;
        max-width: 80%;
        /*transition: all 0.3s ease-out;*/
        border: 1px solid var(--col-light);

        &.no-border {
          border: none;
        }

        &.icon-play {
          width: 25%;
          margin-left: 37.5%;
        }
      }
    }

    div.file {
      img {
        width: 40%;
      }
      .filetype {
        position: absolute;
        width: 100%;
        pointer-events: none;
      }
    }

    &:hover {
      div.caption {
        border: 1px solid var(--col-light);
      }
    }
  }

  .panel-header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    background: var(--black);
    z-index: 9999;

    h3 {
      margin-top: 1em;
    }

    .button-back {
      left: 1em;

      a {
        color: var(--col-light);
      }
    }

    .top-right {
      right: 1em;
      position: fixed;
      top: 1em;
    }
  }

  @media (--phone) {
    .media-panel {
      div.image, div.video, div.file {
        height: 40vw;
      }
    }
  }
</style>
